import { ClientTypes } from '~/constants/clientTypes';
import { ReactNode } from 'react';
import { DOCUMENT_RELATED_ENTITY_TYPE } from '~/modules/identification/forms/Documents/constants.tsx';

export type TDocument = {
  id?: string;
  docStatus: DocStatusEnum[];
  idDictWebDocument: number;
  idDoc: number;
  inn?: string;
  managerId?: string;
  nameDoc: string;
  pib?: string;
  idDocSign?: number | string | null;
  documentName?: string;
  deletionPermission?: DeletionPermissionEnum;
  tooltipText?: ReactNode;
  showInformer?: boolean;
  ownerId?: string;
  relatedEntityId?: string;
  relatedEntityType?: DOCUMENT_RELATED_ENTITY_TYPE;
};

export type TDocType = {
  id: number;
  name: string;
};

export type TDocumentsInStore = {
  documents: TDocuments;
  isCompleted: boolean;
  type: ClientTypes;
  registrationDate: string;
  readyForSigning: boolean | undefined;
  missingForms: string[] | undefined;
  missingDocuments: number[] | undefined;
};

export type TDocuments = {
  additionalDocuments: TDocument[];
  additionalMainDocuments: TDocument[];
  assetManagersDocuments: TDocument[];
  mainDocuments: TDocument[];
};

export enum DocStatusEnum {
  NOT_VERIFIED = 'NOT_VERIFIED',
  INVALID_SIGNATURE = 'INVALID_SIGNATURE',
  MISMATCHED_RNOKPP = 'MISMATCHED_RNOKPP',
  SUCCESS = 'SUCCESS',
  MISMATCHED_EDRPOU = 'MISMATCHED_EDRPOU',
  MISMATCHED_FULLNAME = 'MISMATCHED_FULLNAME',
  ORGANIZATION_ABSENT = 'ORGANIZATION_ABSENT',
  SIGNED_WITH_ELECTRONIC_STAMP = 'SIGNED_WITH_ELECTRONIC_STAMP',
}

export enum DeletionPermissionEnum {
  ALLOWED = 'ALLOWED',
  RESTRICTED = 'RESTRICTED',
  FORBIDDEN = 'FORBIDDEN',
}

export type UboOwnerMap = Record<string, string>;

export type TPerson = {
  firstName?: string;
  lastName?: string;
};

export type TOwnerCandidate = { id: string; label: string };
